import { ApiProvider, LayoutProvider } from "providers";
import { BoardProvider } from "providers";
import { BoardRunsProvider } from "providers";
import { BoardSettingsProvider } from "providers";
import { BoardUsersProvider } from "providers";
import { ParamsProvider } from "providers";
import { PermissionsProvider } from "providers";
import { RunProvider } from "providers";
import { ToastsProvider } from "providers";
import { PropsWithChildren } from "react";

export const AppProviders: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ToastsProvider>
      <ApiProvider>
        <PermissionsProvider>
          <ParamsProvider>
            <BoardProvider>
              <BoardSettingsProvider>
                <BoardRunsProvider>
                  <BoardUsersProvider>
                    <RunProvider>
                      <LayoutProvider>{children}</LayoutProvider>
                    </RunProvider>
                  </BoardUsersProvider>
                </BoardRunsProvider>
              </BoardSettingsProvider>
            </BoardProvider>
          </ParamsProvider>
        </PermissionsProvider>
      </ApiProvider>
    </ToastsProvider>
  );
};
